import { TouchEvent, WheelEvent } from "react";

export function getTouchDirection(touchEvents: TouchEvent[]): number {
  const clientYValues = touchEvents.map((e) => e.changedTouches[0].clientY);
  const [startY, endY] = [
    clientYValues[0],
    clientYValues[clientYValues.length - 1],
  ];

  // > 0: Scrolls down
  // < 0: Scrolls up
  return startY - endY;
}

export function getWheelDirection(wheelEvents: WheelEvent[]): number {
  // > 0: Scrolls down
  // < 0: Scrolls up
  return wheelEvents[0].deltaY;
}
